













































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRole from '@/store/models/IRole';
import Snackbar from '@/components/shared/Snackbar.vue';
import RolePermissionSelector from '@/components/selectors/Role/RolePermissionSelector.vue';
import IRolePermission from '@/store/models/IRolePermission';
import ICompany from '@/store/models/ICompany';
import { EMPTY_GUID } from '@/config/constants';
@Component({
    components: {
        Snackbar,
        RolePermissionSelector
    }
})
export default class RoleSelector extends Vue {
    dialog: boolean = false;
    isValid: boolean = true;
    editedIndex : number = -1;
    editedItem : IRole = {
        id: "",
        roleName: "",
        rolePermissions: [],
        idCompany: ""
    }
    defaultItem : IRole = {
        id: "",
        roleName: "",
        rolePermissions: [],
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    RoleList !: IRole[];
    @Prop({ type: Array, required: true })
    RolePermissionList !: IRolePermission[];
    @Prop({ type: Array })
    CompanyList !: ICompany[];
    @Prop()
    IdCompany !: string;
    roleSelected : IRole = {} as IRole;
    selectedRole : IRole [] = [];
    selectedCompany: any = null;

    get isSuperAdmin() {
        return this.IdCompany === EMPTY_GUID;
    }

    get sortedRoleList() {
        return [...this.RoleList].sort((a, b) => a.roleName.localeCompare(b.roleName));
    }
    
    get formTitle() { return this.editedIndex === -1 ? 'New Role' : 'Edit Role'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('roleSelected')
    onSelectedRole(val: any) {
        this.selectedRole[0] = this.roleSelected;
        this.$emit('onChangeRole', this.selectedRole[0]);
    }

    editRole () {
        this.editedIndex = this.RoleList.indexOf(this.selectedRole[0]);
        this.selectedCompany = this.CompanyList.find(p => p.id === this.selectedRole[0].idCompany);
        this.editedItem = Object.assign({}, this.selectedRole[0]);
        this.dialog = true;
    }

    resetRole () {
        this.selectedCompany = [];
    }

    saveRole (role: IRole) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.isSuperAdmin) {
                this.editedItem.idCompany = this.selectedCompany.id;
            } else {
                this.editedItem.idCompany = this.IdCompany;
            }
            if (this.editedIndex > -1) {
                this.$emit('editRole', this.editedItem);
                Object.assign(this.RoleList[this.editedIndex], this.editedItem);
            } else {
                this.selectedRole[0] = this.editedItem;
                this.$emit('saveRole', this.editedItem);
                this.roleSelected = this.selectedRole[0];
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteRole () {
        this.$emit('deleteRole', this.selectedRole[0]);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
    
    editRolePermission(item: IRolePermission) {
        this.$emit("editRolePermission", item);
    }

    saveRolePermission(item: IRolePermission) {
        this.$emit("saveRolePermission", item);
    }
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
